function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import React from 'react';
export var useFreshStaticValue = function useFreshStaticValue(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ref = React.useRef(value); // 对象默认 merge

  var _options$type = options.type,
      type = _options$type === void 0 ? _typeof(value) === 'object' ? 'merge' : 'replace' : _options$type,
      _options$needToUpdate = options.needToUpdate,
      needToUpdate = _options$needToUpdate === void 0 ? value : _options$needToUpdate;

  if (type === 'replace') {
    ref.current = needToUpdate;
  } else {
    Object.assign(ref.current, needToUpdate);
  }

  return ref;
};